import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';
import { expValEquals } from '@confluence/feature-experiments';

import { GetDraftParentQuery } from './GetDraftParentQuery.graphql';

/**
 * Gets the contentId of the specified draft content's parent by looking in the GraphQL cache.
 * If it's unable to find the parent, returns undefined.
 */
export const getParentOfDraft = async (
	contentId: string,
	readFragmentInterop: any,
): Promise<string | undefined> => {
	const apolloClient = getApolloClient();
	// Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
	// We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
	let parentId = undefined;
	try {
		if (expValEquals('remove_usages_of_cache_read_write', 'isEnabled', true)) {
			const draftData = readFragmentInterop({
				id: `Content:${contentId}`,
			});
			parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
		} else {
			// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
			const draftParentQueryResult = await apolloClient.readQuery({
				query: GetDraftParentQuery,
				variables: {
					contentId,
				},
			});
			parentId = draftParentQueryResult?.content?.nodes?.[0]?.ancestors?.slice(-1)?.[0]?.id;
		}
	} catch {}

	return parentId;
};
